export function CreateElementAspect(createElement, createElementFromHtml){
    return {
        createElement,
        createElementFromHtml
    }
}